import React from 'react';
import { clsx } from 'clsx';
import { Colors, FontSize } from '@common/tokens';
import { ZonedTime } from '@common/components/zoned-time';
import { PostMessageEmpty } from './_post-message-empty';
import { Col, Row } from 'antd';

export type PostMessageProps = {
  message: string;
  name?: string;
  time: string;
  className?: string;
  external?: boolean;
};

export const PostMessage = ({
  message,
  name,
  time,
  className,
  external,
}: PostMessageProps) => (
  <>
    <div
      className={clsx('wk-post-message', className, {
        'wk-post-message--external': external,
      })}
    >
      <Row>
        <Col span={18} offset={external ? 6 : 0}>
          <div className="wk-post-message__position-handler">
            <span className="wk-post-message__text">{message}</span>
          </div>
          <div className="wk-post-message__meta-info sentry-mask">
            {!!name && `${name}, `}
            <ZonedTime date={time || ''} variant="long_format" />
          </div>
        </Col>
      </Row>
    </div>
    <style jsx>{`
      .wk-post-message__text {
        padding: 16px;
        font-size: ${FontSize.md};
        border-radius: 4px;
        margin-bottom: 2px;
        display: inline-block;
        background-color: ${Colors.grassLightest};
      }

      .wk-post-message__meta-info {
        font-size: 13px;
        color: ${Colors.midnightLighter};
      }

      .wk-post-message--external .wk-post-message__position-handler {
        display: flex;
        flex-direction: row-reverse;
      }

      .wk-post-message--external .wk-post-message__text {
        background-color: ${Colors.skyHyperLight};
      }

      .wk-post-message--external .wk-post-message__meta-info {
        text-align: right;
      }
    `}</style>
  </>
);

PostMessage.Empty = PostMessageEmpty;
